import { ArraySelectOptionType } from '@wildberries/ui-kit/lib/select/types';
import { TSearchMultiInputOptionsArray } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';

type TFirstFilteredWarehousesSearchParamsCase = {
  warehouses: TSearchMultiInputOptionsArray;
  value: string;
};

type TSecondFilteredWarehousesSearchParamsCase = {
  warehouses: ArraySelectOptionType;
  value: string;
};

type TFilteredWarehousesSearchOverload = {
  (
    params: TFirstFilteredWarehousesSearchParamsCase,
  ): TSearchMultiInputOptionsArray;
  (params: TSecondFilteredWarehousesSearchParamsCase): ArraySelectOptionType;
};

export const filteredWarehousesSearch: TFilteredWarehousesSearchOverload = ({
  warehouses,
  value,
}) => {
  return warehouses.filter((warehouse) =>
    warehouse.label
      ? warehouse.label.toLocaleLowerCase().includes(value.toLocaleLowerCase())
      : warehouse.title.toLocaleLowerCase().includes(value.toLocaleLowerCase()),
  );
};
